export const REGISTER = "/register";
export const LOGIN = "/login";
export const RESET_PASSWORD = "/reset-password";
export const FORGET_PASSWORD = "/forget";
export const VERIFY = "/verify";

export const COMPANIES_LIST = "/companies";
export const NEW_OR_EDIT_COMPANY = "/company";

export const PURCHASE = "/purchase";
export const INVITATION = "/invitation";

export const EDIT = `edit`;
export const ADD = `add`;

export const DASHBOARD_PETTY_CASHIER = "/petty-cashier";
export const DASHBOARD_MANAGER = "/manager";

export const CREATE_DATA_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/create-data`;

export const PAYMENT = "payment";
export const PRE_PAYMENT_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/pre-${PAYMENT}`;
export const ADD_PAYMENT_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/add-${PAYMENT}`;
export const EDIT_PAYMENT_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/edit-${PAYMENT}`;
export const SUMMARY_PAYMENT_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/summary-${PAYMENT}`;

export const RECEIVE = "receive";
export const PRE_RECEIVE_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/pre-${RECEIVE}`;
export const ADD_RECEIVE_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/add-${RECEIVE}`;
export const EDIT_RECEIVE_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/edit-${RECEIVE}`;
export const SUMMARY_RECEIVE_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/summary-${RECEIVE}`;

export const PETTY_CASH_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/pettycash`;
export const PETTY_CASH_REPORTS_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/pettycash_report`;
export const SUMMARY_PETTY_CASH_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/summary-pettycash`;

export const ACCOUNT_REVIEW_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/account-review`;

export const COST_CLASSIFICATION_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/cost-classification`;
export const COST_CLASSIFICATION_DETAIL_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/cost-classification/detail`;

export const VAT_REVIEW_REPORT_PETTY_CASHIER = `${COST_CLASSIFICATION_PETTY_CASHIER}/vat-review`;

export const MONTHLY_SELECT_REPORT_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/monthly-report`;
export const MONTHLY_REVIEW_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/monthly-report/review`;
export const MONTHLY_DETAIL_REVIEW_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/monthly-report/detail`;

export const SUMMARY_PETTY_CASH_BUDGET_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/summary-pettycash-budget`;
export const CURRENT_PETTY_CASH_BUDGET_COMPARISON_REPORT_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/current-pettycash-budget-comparison`;
export const MONTHLY_BUDGET_REVIEW_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/monthly-report/budget-review`;
export const MONTHLY_BUDGET_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/monthly-report/budget`;
export const MONTHLY_BUDGET_COPY_PETTY_CASHIER = `${MONTHLY_BUDGET_PETTY_CASHIER}-copy`;

export const SUMMARY_MONTHLY_BUDGET_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/summary-monthly-budget`;

export const CONTACTS_BASE_ACTIVITY_REVIEW_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/contacts-report`;
export const CONTACTS_ACTIVITY_REVIEW_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/contacts-report/review`;
export const CONTACTS_DETAIL_REVIEW_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/contacts-report/detail`;

export const CONTACTS_BASE_ACTIVITY_REVIEW_MANAGER = `${DASHBOARD_MANAGER}/contacts-report`;
export const CONTACTS_ACTIVITY_REVIEW_MANAGER = `${DASHBOARD_MANAGER}/contacts-report/review`;
export const CONTACTS_DETAIL_REVIEW_MANAGER = `${DASHBOARD_MANAGER}/contacts-report/detail`;

export const USER_ACCOUNT_SETTING = `/user-account-setting`;
export const USER_ACCOUNT_SETTING_EDIT = `${USER_ACCOUNT_SETTING}/edit`;
export const USER_ACCOUNT_SETTING_CHANGE_PASSWORD = `${USER_ACCOUNT_SETTING}/change-password`;
export const USER_ACCOUNT_SETTING_PAYMENTS_HISTORY = `${USER_ACCOUNT_SETTING}/payments-history`;

export const PROJECT_SETTING = `/project-setting`;
export const PROJECT_SETTING_BASIC_INFO = `/basic-info`;
export const PROJECT_SETTING_ACCOUNTING_SOFTWARE = `/project-setting/accounting-software`;
export const PROJECT_SETTING_TRANSACTION_FORM = `${PROJECT_SETTING}/transaction-form-setting`;
export const PROJECT_SETTING_PAYMENT_VALIDATION = `${PROJECT_SETTING}/payment-validation-setting`;
export const PROJECT_SETTING_CONNECT_TO_PARTNERS = `${PROJECT_SETTING}/connect-to-partners`;
export const PROJECT_SETTING_TRANSACTION_DAY_LIMIT = `${PROJECT_SETTING}/transaction-day-limit`;

export const SHOW_TEAM = `/show_team`;
export const REORDER = `/reorder`;
export const TEAM = `/team`;
export const LEVELS = `/levels`;

export const TICKETS = `/tickets`;
export const TICKET = `/ticket`;

export const CONTACT = `/contact`;
export const COST_CENTER = `/cost-center`;
export const ACCOUNT_TITLE = `/account-title`;
export const ACCOUNT_TITLE_SUMMARY = `/account-title-summary`;
export const ACCOUNT_TITLE_UPLOAD_EXCEL = `/account-title/upload-excel`;
export const EDIT_ACCOUNTING = `/${EDIT}/accounting`;

export const PROJECTS_MANAGEMENT = `/projects-management`;
export const PROJECT_MEMBER_MANAGEMENT = `/project-member-management`;
export const PROJECT_MEMBER_PROFILE = `/project-member-profile`;

export const FILES = `/files`;

export const TRANSACTIONS_IMPORT_EXCEL = `/transactions-import-excel`;

export const BACKUP = `/backup`;

export const CREATE_DATA_MANAGER = `${DASHBOARD_MANAGER}/create-data`;

export const PRE_PAYMENT_MANAGER = `${DASHBOARD_MANAGER}/pre-payment`;
export const ADD_PAYMENT_MANAGER = `${DASHBOARD_MANAGER}/add-payment`;
export const EDIT_PAYMENT_MANAGER = `${DASHBOARD_MANAGER}/edit-payment`;
export const SUMMARY_PAYMENT_MANAGER = `${DASHBOARD_MANAGER}/summary-payment`;

export const PRE_RECEIVE_MANAGER = `${DASHBOARD_MANAGER}/pre-receive`;
export const ADD_RECEIVE_MANAGER = `${DASHBOARD_MANAGER}/add-receive`;
export const EDIT_RECEIVE_MANAGER = `${DASHBOARD_MANAGER}/edit-receive`;
export const SUMMARY_RECEIVE_MANAGER = `${DASHBOARD_MANAGER}/summary-receive`;

// export const PETTY_CASH_MANAGER = `${DASHBOARD_MANAGER}/pettycash`;
export const PETTY_CASH_REPORTS_MANAGER = `${DASHBOARD_MANAGER}/pettycash_report`;
export const TRASHED_PETTY_CASH_REPORTS_MANAGER = `${DASHBOARD_MANAGER}/pettycash_report/trashed`;
export const SUMMARY_PETTY_CASH_MANAGER = `${DASHBOARD_MANAGER}/summary-pettycash`;

export const PETTY_CASH_BUDGET_REPORT_MANAGER = `${DASHBOARD_MANAGER}/pettycash-budget-report`;
export const PETTY_CASH_BUDGET_MANAGER = `${DASHBOARD_MANAGER}/pettycash-budget`;
export const PETTY_CASH_BUDGET_COPY_MANAGER = `${PETTY_CASH_BUDGET_MANAGER}-copy`;
export const SUMMARY_PETTY_CASH_BUDGET_MANAGER = `${DASHBOARD_MANAGER}/summary-pettycash-budget`;

export const ACCOUNT_REVIEW_MANAGER = `${DASHBOARD_MANAGER}/account-review`;

export const COST_CLASSIFICATION_MANAGER = `${DASHBOARD_MANAGER}/cost-classification`;
export const COST_CLASSIFICATION_DETAIL_MANAGER = `${DASHBOARD_MANAGER}/cost-classification/detail`;

export const VAT_REVIEW_REPORT_MANAGER = `${COST_CLASSIFICATION_MANAGER}/vat-review`;

export const HASHTAG = `/hashtag`;

export const HASHTAGS_SELECT_REPORT_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/hashtags-report`;
export const HASHTAGS_REVIEW_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/hashtags-report/review`;
export const HASHTAGS_ACTIVITY_REVIEW_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/hashtags-report/activity`;
export const HASHTAGS_DETAIL_REVIEW_PETTY_CASHIER = `${DASHBOARD_PETTY_CASHIER}/hashtags-report/detail`;

export const HASHTAGS_SELECT_REPORT_MANAGER = `${DASHBOARD_MANAGER}/hashtags-report`;
export const HASHTAGS_REVIEW_MANAGER = `${DASHBOARD_MANAGER}/hashtags-report/review`;
export const HASHTAGS_ACTIVITY_REVIEW_MANAGER = `${DASHBOARD_MANAGER}/hashtags-report/activity`;
export const HASHTAGS_DETAIL_REVIEW_MANAGER = `${DASHBOARD_MANAGER}/hashtags-report/detail`;

export const MY_TEAM_MEMBER_MANAGEMENT = `/my-team-member-management`;
export const INVITE = `/invite`;
export const MEMBER_PROFILE = `/member-profile`;
export const PROJECT_PROFILE = `/project-profile`;
export const PROJECT_MEMBER_EDIT_ACCOUNTING_CODES = `${PROJECT_MEMBER_PROFILE}/edit-accounting-code`;
export const PROJECT_MEMBER_EDIT_IMPREST_PAYMENT_LIMIT = `${PROJECT_MEMBER_PROFILE}/edit-imprest-payment-limit`;
export const SHARED_PROJECTS_MANAGEMENT = `/shared-projects-managements`;
export const SHOW_OWNER_USERS = `/show-owner-users`;
